import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  () =>
    createStyles({
      itensAnexoPautaRow: {
        gap: '16px',
      },
      actions: {
        margin: '8px 0 16px',
      },
    }),
  {
    name: 'CadastroPautaModal',
  }
);
